import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'error-dialog',
  styleUrls: ['./error-dialog.component.scss'],
  templateUrl: './error-dialog.component.html',
  standalone: false,
})
export class ErrorDialogComponent {
  public title: string = '';
  public message: string = '';

  constructor(public dialogRef: MatDialogRef<ErrorDialogComponent>) {}
}
